import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getCentralisedAirlineImagesDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  centralizedAirlineTailImage: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Airline Name",
      fieldValue: "airline_name",
      className: "col-span-6",
      type: "text",
      name: "airline_name",
      formType: "input",
      label: "Airline Name",
      placeholder: "Airline Name",
      validation: { required: "Airline Name is required" },
    },
    {
      fieldName: "Airline Code",
      fieldValue: "airline_code",
      className: "col-span-6",
      type: "text",
      name: "airline_code",
      formType: "input",
      label: "Airline Code",
      placeholder: "Airline Code",
      validation: { required: "Airline Code is required" },
    },
    // {
    //   fieldName: "MAGP Published",
    //   fieldValue: "magp_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "magp_sync",
    //   formType: "checkbox",
    //   label: "MAGP Published",
    //   placeholder: "Enter MAGP Published",
    //   // validation: { required: "MAGP Publish is required" },
    // },
    // {
    //   fieldName: "ERAMAN Published",
    //   fieldValue: "eraman_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "eraman_sync",
    //   formType: "checkbox",
    //   label: "ERAMAN Published",
    //   placeholder: "Enter ERAMAN Published",
    //   // validation: { required: "ERAMAN Publish is required" },
    // },
    // {
    //   fieldName: "CORPORATE Published",
    //   fieldValue: "corporate_sync",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "corporate_sync",
    //   formType: "checkbox",
    //   label: "CORPORATE Published",
    //   placeholder: "Enter CORPORATE Published",
    //   // validation: { required: "CORPORATE Publish is required" },
    // },
    // {
    //   fieldName: "PASSENGER Published",
    //   fieldValue: "published",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "published",
    //   formType: "checkbox",
    //   label: "PASSENGER Published",
    //   placeholder: "Enter PASSENGER Published",
    //   // validation: { required: "PASSENGER Publish is required" },
    // },
    // {
    //   fieldName: "Modules / Airports",
    //   fieldValue: "module_name",
    //   className: "col-span-6",
    //   type: "select",
    //   name: "module_name",
    //   formType: "multiSelect",
    //   label: "Modules / Airports",
    //   placeholder: "Enter Modules / Airports",
    //   validation: { required: "Modules / Airports is required" },
    //   loadOptions: fetchMouleSelection
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
};
